import { render } from "./pca-form-select-box.vue?vue&type=template&id=10ff2be0"
import script from "./pca-form-select-box.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-form-select-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-form-select-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10ff2be0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10ff2be0', __exports__)) {
    api.reload('10ff2be0', __exports__)
  }
  
  module.hot.accept("./pca-form-select-box.vue?vue&type=template&id=10ff2be0", () => {
    api.rerender('10ff2be0', render)
  })

}


export default __exports__